<template>
  <neb-modal class="tableColumnsModal"
    :isOpen="isOpen"
    title="Customize Columns"
    @clickOutside="$emit('close')"
  >

    <div class="tableColumnsModal-content">
      <div class="tableColumnsModal-content-controls">
        <a class="selectAll"
          @click="onSelectAll"
        >
          Select All
        </a>

        <div class="divider"></div>

        <a class="unselectAll"
          @click="onUnselectAll"
        >
          Clear All
        </a>
      </div>

      <neb-checkbox-group v-model="localSelectedColumns"
        :options="options"
        columns="two"
      ></neb-checkbox-group>
    </div>

    <template v-slot:footer>
      <neb-control grouped>
        <neb-button type="secondary"
          @click="$emit('close')"
        >Cancel</neb-button>

        <neb-button type="primary"
          @click="onSubmit"
        >Apply</neb-button>
      </neb-control>
    </template>
  </neb-modal>
</template>

<script>
const tableColumnOptions = [
  { label: 'Title', value: 'title', section: 'Content'},
  { label: 'Source', value: 'source', section: 'Content' },
  { label: 'URL', value: 'urls', section: 'Content' },
  { label: 'Date', value: 'date', section: 'Content' },
  { label: 'Duration', value: 'avg_duration', section: 'Content' },
  { label: 'Word Count', value: 'avg_word_count', section: 'Content' },

  { label: 'Total Views', value: 'page_views', section: 'Views' },
  { label: 'Scroll Initiations', value: 'scroll_initiations', section: 'Views' },
  { label: 'Scroll Initiation Rate', value: 'pct_scroll_initiations', section: 'Views' },
  { label: 'Avg. Scroll Depth Percent', value: 'avg_scroll_depth', section: 'Views' },

  { label: 'Social Actions', value: 'social_actions', section: 'Social Actions' },
  { label: 'Social Likes', value: 'likes', section: 'Social Actions' },
  { label: 'Social Comments', value: 'comments', section: 'Social Actions' },
  { label: 'Social Shares', value: 'shares', section: 'Social Actions' },

  { label: 'Avg. Percent Consumed', value: 'avg_pct_consumed', section: 'Consumption' },
  { label: 'Total Time on Content', value: 'active_time', section: 'Consumption' },
  { label: 'Avg. Time on Content', value: 'avg_active_time', section: 'Consumption' },
  { label: 'Avg. Completion Rate', value: 'avg_completion', section: 'Consumption' },

  { label: 'Total Conversions', value: 'conversions', section: 'Conversions' },
  { label: 'Conversion Rate', value: 'pct_conversions', section: 'Conversions' },

  { label: 'Keywords', value: 'keywords', section: 'Characteristics' },
  { label: 'Topics', value: 'topics', section: 'Characteristics' },
  { label: 'Properties', value: 'properties', section: 'Characteristics' },
  { label: 'Is Sponsored', value: 'is_sponsored', section: 'Characteristics' }
]

export default {
  name: 'TableColumnsModal',

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedColumns: {
      type: Array,
      default: () => []
    }
  },

  data: () => ({
    options: tableColumnOptions,
    localSelectedColumns: []
  }),

  methods: {
    onSubmit () {
      this.$emit('submit', this.localSelectedColumns)
    },
    onSelectAll () {
      this.localSelectedColumns = this.options
        .map(opt => opt.value)
    },
    onUnselectAll () {
      this.localSelectedColumns = []
    }
  },

  watch: {
    selectedColumns (newVal) {
      this.localSelectedColumns = newVal
    },
    isOpen (newVal) {
      if (newVal) {
        this.localSelectedColumns = this.selectedColumns
      }
    }
  },

  mounted () {
    this.localSelectedColumns = this.selectedColumns
  }
}
</script>

<style lang="scss">
.tableColumnsModal {
  &-content {
    width: 460px;
    max-height: 400px;
    overflow-y: scroll;

    &-controls {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      padding-right: 40px;

      .divider {
        width: 2px;
        background-color: #cecece;
        height: 15px;
        margin: 0 0.5em;
      }

      a {
        display: block;
      }
    }
  }
}
</style>
